import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminSidebar.css';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
function AdminSidebar({ user }) {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => setIsOpen(!isOpen);
  const closeSidebar = () => setIsOpen(false);

  const handleNav = (path) => {
    navigate(path);
    closeSidebar();
  };
  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (err) {
      console.error('Logout failed:', err);
    }
  };

  return (
    <>
      {/* Floating Hamburger */}
      {!isOpen && (
      <button className="hamburger-float" onClick={toggleSidebar}>☰</button>
    )}

      {/* Sidebar */}
      <div className={`drawer-menu ${isOpen ? 'open' : ''}`}>
        <div className="drawer-close" onClick={closeSidebar}>×</div>

        <div className="user-info" style={{ marginBottom: '2rem' }}>
          <strong>{user?.name || 'Admin'}</strong>
          <p style={{ fontSize: '0.9rem' }}>{user?.email || ''}</p>
        </div>

        <div className="drawer-links">
          <p onClick={() => handleNav('/admin')}>Dashboard</p>
          <p onClick={() => handleNav('/admin/create-po')}>Create PO</p>
          <p onClick={() => handleNav('/admin/assign-po')}>Assign PO</p>
          <p onClick={() => handleNav('/admin/edit-po')}>Edit PO</p>
          <p onClick={() => handleNav('/admin/view-progress')}>Project Managers</p>
          <p onClick={() => handleNav('/admin/manage-users')}>Manage Users</p>
          <p onClick={() => handleNav('/admin/vendor-material-manager')}>Add Material</p>
         
         
        </div>
        <button className="logout-btn" onClick={handleLogout}>Logout</button>
        <div className="sidebar-footer" style={{ marginTop: 'auto', fontSize: '0.9rem' }}>
          <p>© Ideator Engineering<br />2025</p>
        </div>
      </div>

      {/* Backdrop */}
      {isOpen && <div className="drawer-backdrop" onClick={closeSidebar}></div>}
    </>
  );
}

export default AdminSidebar;
